import "./styles.css";
import Main from "./App/Main";
import "bootstrap/dist/css/bootstrap.min.css";



export default function App() {
  return (
    <div className="App" style={{ height: "100vh", width: "100vw" }}>
      <Main />
    </div>
  );
}
